<soft-page>
  <ng-content>
    @if(item(); as item){
    <div class="flex flex-col gap-3">
      <soft-ds-card>
        <soft-ds-card-body>
          <div class="grid grid-cols-2 items-center gap-3">
            <span class="text-light">Lieferschein</span>
            <span class="text-right">LS {{item.belegnummer }}</span>
            <span class="text-light">Kunde</span>
            <span class="text-right">
              {{ item.adresseBean?.vorname }} {{ item.adresseBean?.nachname }}
            </span>
          </div>
        </soft-ds-card-body>
      </soft-ds-card>

      <div>
        <span class="text-light">
          {{'#DELIVERY_NOTE.DETAILS.PALETTEN_MODUS.'+item.palettenModus | translate}}
        </span>
        <div class="flex justify-between items-center gap-3">
          <soft-ds-progress-bar
            [value]="progressBarValue()"
            [severity]="
                item.palettenModus === PalettenModus.Erledigt ? 'success' : 'warning'
              "
          />
          <span
            class="text-sm"
            [class]="
              item?.palettenModus === PalettenModus.Erledigt
                ? 'text-success-600'
                : 'text-warning-600'
            "
          >
            {{ numOfErledigtPaletten() }}/{{ item.paletten.length }}
          </span>
        </div>
      </div>

      <div>
        <span class="font-semibold text-sm uppercase">Lademittel</span>
        <section class="flex flex-col gap-2">
          @for(palette of item.paletten; track palette.id){
          <soft-ds-card [chevron]="true" (click)="navigate(palette.id)">
            <soft-ds-card-body>
              <div class="flex flex-row items-center gap-3">
                @if (palette.auslieferungsstatus === palettenModus() ||
                numOfErledigtPaletten() === item.paletten.length ) {
                <div
                  class="flex items-center justify-center w-10 h-10 rounded-lg bg-success-400 shrink-0"
                >
                  <soft-icon name="fa-regular fa-check text-success-700 text-lg" />
                </div>
                } @else {
                <div
                  class="flex items-center justify-center w-10 h-10 rounded-lg bg-surface-tertiary shrink-0"
                >
                  <soft-icon name="fa-regular fa-square text-lg" />
                </div>
                }
                <div class="flex flex-col flex-1">
                  <span class="font-semibold">
                    SSCC
                    <span class="hidden sm:inline">{{palette.ssccnummer}}</span>
                    <span class="sm:hidden">
                      ...{{palette.ssccnummer?.toString()?.slice(-4)}}
                    </span>
                  </span>
                  <span class="text-light">{{palette.artikelmengen.length}} Artikel</span>
                </div>
                <soft-ds-badge size="lg" variant="outline">
                  {{(palette.auslieferungsstatus === palettenModus() ||
                  numOfErledigtPaletten() === item.paletten.length) ? 'Erledigt':
                  'Offen'}}
                </soft-ds-badge>
              </div>
            </soft-ds-card-body>
          </soft-ds-card>
          }
        </section>
      </div>
    </div>

    <soft-page-footer>
      <div class="flex flex-cols gap-2">
        <soft-ds-button
          variant="outline"
          size="lg"
          mode="iconOnly"
          style="--ds-button-height-lg: 3.5rem"
          [disabled]="item.palettenModus === PalettenModus.Erledigt"
          (click)="startCamera()"
        >
          <soft-icon name="fa-regular fa-camera" />
        </soft-ds-button>
        <soft-ds-button
          variant="primary"
          size="lg"
          class="w-full"
          style="--ds-button-height-lg: 3.5rem"
          [disabled]="numOfErledigtPaletten() !== item.paletten.length"
          (click)="navigateToDeliveryNote()"
        >
          {{'#DELIVERY_NOTE.DETAILS.PALETTEN_MODUS.'+item.palettenModus | translate}}
          Abschließen
        </soft-ds-button>
      </div>
    </soft-page-footer>
    }
  </ng-content>
</soft-page>
